module.exports = __webpack_public_path__ + "img/g3.37645dc5.png";